// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".send-request-reply-message[data-v-ea7fcd84]{border:1px solid #dcdcdc;border-radius:.5rem}.send-request-reply-message .datetime[data-v-ea7fcd84]{font-size:14px;color:#707070}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
